"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDBEpoch = exports.epochsToSamples = exports.epochToSamples = void 0;
const _1 = require(".");
function epochToSamples(epoch, nextStart) {
    const start = new Date(epoch.info.startTime);
    const end = nextStart ? new Date(nextStart) : new Date(start.getTime() + epoch.info.samplingRate);
    const delta = (end.getTime() - start.getTime()) / epoch.data[0].length;
    return _1.transpose(epoch.data).map((d, i) => ({
        data: d,
        index: i,
        timestamp: new Date(start.getTime() + delta * i).getTime(),
    }));
}
exports.epochToSamples = epochToSamples;
function epochsToSamples(epochs, allowDuplicates = false, sampling = 'auto') {
    function getSamples() {
        if (sampling == 'auto') {
            const startTimes = epochs.map((e) => e.info.startTime);
            // TODO: don't just remove last item
            return epochs
                .slice(0, epochs.length - 1)
                .map((e, i) => epochToSamples(e, startTimes[i + 1]))
                .flat();
        }
        return epochs.map(epochToSamples).flat();
    }
    const samples = getSamples();
    if (allowDuplicates)
        return samples;
    return _1.uniques(samples, 'timestamp');
}
exports.epochsToSamples = epochsToSamples;
function parseDBEpoch(dbEpoch) {
    const { samples, samplingRate, startTime, bufferDuration, bufferInterval } = dbEpoch;
    // sort samples after channel index
    const _samples = samples.slice().sort((a, b) => {
        if (a.channel < b.channel)
            return -1;
        if (a.channel > b.channel)
            return 1;
        return 0;
    });
    return {
        data: _samples.map((s) => s.data),
        info: {
            samplingRate: samplingRate,
            startTime: startTime,
            bufferDuration: bufferDuration,
            bufferInterval: bufferInterval,
        },
        packetLoss: [{ index: 0, skipped: 0 }],
    };
}
exports.parseDBEpoch = parseDBEpoch;
//# sourceMappingURL=epoch.js.map